module.exports = __webpack_public_path__ + "static/media/QUEZON.d882c8b6.png";